import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  IonText,
  IonItem,
  IonLabel,
  IonToggle,
  IonThumbnail,
  IonImg
} from '@ionic/react';
import { observer } from 'mobx-react-lite';
import { arrowForwardCircle } from 'ionicons/icons';
import { getUrlFromPath } from 'libs/helpers/helper.lib';

import classes from './style.module.scss';
import exerciseStore from 'stores/exercise.store';
import { toJS } from 'mobx';

const WorkoutExercise = ({
  workoutAssignmentId,
  workoutExercise,
  repetition_no,
  status,
  handleWorkoutStatusToggle
}) => {
  const { push } = useHistory();
  const [exercise, setExercise] = useState(null);

  useEffect(() => {
    let final_repetition_count_left =
      workoutExercise.repetition_numbers_left +
      workoutExercise.repetition_incremental_left * (repetition_no - 1);

    if (final_repetition_count_left > workoutExercise.max_repetition_left) {
      final_repetition_count_left = workoutExercise.max_repetition_left;
    }

    let final_repetition_count_right =
      workoutExercise.repetition_numbers_right +
      workoutExercise.repetition_incremental_right * (repetition_no - 1);

    if (final_repetition_count_right > workoutExercise.max_repetition_right) {
      final_repetition_count_right = workoutExercise.max_repetition_right;
    }
    setExercise({
      ...workoutExercise,
      repetition_numbers_left: final_repetition_count_left,
      repetition_numbers_right: final_repetition_count_right
    });
  }, [workoutExercise, repetition_no]);

  return (
    <IonItem
      color='primary'
      button
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        exerciseStore.setObject(exercise);
        push(`/workouts/${workoutAssignmentId}/exercise`);
      }}
      detail={true}
      detailIcon={arrowForwardCircle}
      className={classes.workoutExercise}
    >
      <IonThumbnail slot='start'>
        <IonImg
          src={getUrlFromPath(workoutExercise.exercise.thumbnail)}
          alt={workoutExercise.exercise.name}
        />
      </IonThumbnail>
      <IonLabel>
        <div className={classes.workoutExerciseTitle}>
          <IonText className='bold'>{workoutExercise.exercise.name}</IonText>
        </div>
        <div className={classes.workoutExerciseReps}>
          {workoutExercise?.exercise.laterality === 'UNILATERAL' ? (
            <>
              <IonText className='bold'>
                x{exercise?.repetition_numbers_left}L
              </IonText>
              <IonText className='bold'>
                x{exercise?.repetition_numbers_right}R
              </IonText>
            </>
          ) : (
            <>
              <IonText className='bold'>
                x{exercise?.repetition_numbers_left}
              </IonText>
            </>
          )}
        </div>
        <div className={classes.workoutExerciseStatus}>
          <IonToggle
            color='success'
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              handleWorkoutStatusToggle(e.target.checked);
            }}
            checked={status}
          />

          <IonText className='small'>
            {status ? 'Completed' : 'Incomplete'}
          </IonText>
        </div>
      </IonLabel>
    </IonItem>
  );
};

export default observer(WorkoutExercise);
